export default "__VITE_ASSET__DqS$2oSL__"